import {ObjectId} from "bson";

export default interface POSAType extends POSATypeBase {
  _id: ObjectId;
}

export interface POSATypeBase {
  name: string;
  nameL?: Record<string, string>;
  utmName: string;
  priority?: number;
  shortId: string;
  defaultShouldCreateBill: boolean;
  unitPrice?: number;
  hasPriceList: boolean;
  hide: boolean;
  helloPrintSlug?: string;
  helloPrintProductKey?: string;
  helloPrintSKU?: string;
  isTakeaway?: boolean;
  isOnTheSpot?: boolean;
  imgs?: string[];
  sendToHelloPrint?: boolean;
  noMarkup: boolean;
  desc?: string;
  format: POSA_FORMAT;
  isCustom?: boolean;
  isSaas?: boolean;
  hideInSaaSCatalog?: boolean;
  ratio: POSA_RATIO;
  isOnline?: boolean;
  applyQRCodeRotation?: boolean;
  links?: {
    svg: Record<POSA_WORDINGS, string>
    png: Record<POSA_WORDINGS, string>
  }
  flags?: {
    qrCodeNoBg: number
    hideBGColor: number
    hidePrimaryColor: number
    hideAccentColor: number
    hideSubtitleColor: number
    hideWordings: number
    renderTitleColorAsBackgroundColor?: number
    renderSubTitleColorAsForegroundColor?: number
    colorWhiteAsBackground?: number
    pegLogoX?: number
    useBackgroundForQrCode?: number
  }
}

export enum POSA_WORDINGS {
  gift = "cadeau",
  iphone = "iphone",
  stay = "sejour",
  dish = "plat",
  dish_drink = "plats_boissons",
  cocktail = "cocktail",
  pizza = "pizza",
  burger = "burger",
  meal = "repas",
}

export type POSA_FORMAT =
  | "flyer_a5"
  | "flyer_a6"
  | "chevalet_a5"
  | "chevalet_a6"
  | "poster_a2"
  | "poster_a3"
  | "poster_a4"
  | "stickers10x10"
  | "stickers_dome"
  | "a_long"
  | "businesscardsstandard"
  | "kakemono"
  | "online-ig-story"
  | "online-ig-post"

  /**
   * These formats are not generated by us,
   * but uploaded by the customers.
   */
  | "table_set"
  | "paper_menu"
  | "delivery_bag"
  | "print_on_packaging"
  | "print_on_bag";

export type POSA_RATIO =
  | "a6"
  | "circle"
  | "online-ig-story"
  | "online-ig-post"
  | "kakemono"
  | "businesscardsstandard"
  | "a_long";

export interface POSATypeJavascriptDTO extends POSATypeBase {
  _id: string;
}

export interface POSATypeJavaDTO extends POSATypeBase {
  id: string;
}
